import { formatDateAsString } from "@SonarCX/components/molecules/CustomFieldInput/Date";
import { isUUID } from "@SonarCX/utilities";
import { getFormatted } from "@SonarCX/utilities/phoneNumber";

const getName = (val: string, data: any[]) => {
  const item = data.find((d) => d?.id === val);
  return (item?.name ?? "") as string;
};

export type FormatValueTypes = {
  val: string | string[] | null;
  type: string;
  users: Record<string, LocalUser>;
  customFields: LocalCustomField[];
};

export type GetDisplayTypeArgs = {
  type: string;
  customFields: LocalCustomField[];
};

export type GetFormattedFieldValueArgs = {
  field: LocalCustomField;
  val: string;
  users: FormatValueTypes["users"];
};

const getFormattedFieldValue = ({
  field,
  val,
  users,
}: GetFormattedFieldValueArgs) => {
  const type = field.field_type;

  switch (type) {
    case "boolean":
      return val === "true" ? "checked" : "unchecked";
    case "date-only":
    case "date-time":
    case "month-year":
      return formatDateAsString({ type, date: new Date(val) });
    case "multiline":
    case "text":
    case "dropdown":
      return val;
    case "user":
      return getName(val, Object.values(users));
    case "phone":
      return getFormatted(val);
    case "multiselect":
      return val.split("|").join(", ");
    case "flow":
    case "table":
      return "";
    default:
      console.warn("Unhandled field type:", type);
      return val;
  }
};

export const formatValue = ({
  val,
  type,
  users,
  customFields,
}: FormatValueTypes) => {
  if (!val) {
    return null;
  }

  if (isUUID(type)) {
    const field = customFields.find((field) => field.id === type);
    if (field) {
      return getFormattedFieldValue({ field, val: val as string, users });
    }
  }

  console.warn("Unhandled user activity type:", type);
  return null;
};

export const getDisplayType = ({ type, customFields }: GetDisplayTypeArgs) => {
  if (isUUID(type)) {
    const field = customFields.find((field) => field.id === type);
    if (field) {
      return field.title;
    }
  }

  console.warn("Unknown user activity type:", type);
  return null;
};
